var position = $(window).scrollTop(); 
$(window).scroll(function() {
  var scroll = $(window).scrollTop();
  if (scroll < 10) {
    $('.navigation').removeClass("navigation_scrolled");
  } else {
    $('.navigation').addClass("navigation_scrolled");
  }
});
